// Miniaturas de los widgets, tomadas directamente de los assets de la app
// Electron en tiempo de build (Vite las copia a dist/assets con hash). Así
// no hay duplicados en el repo y salen las mismas imágenes que ve el usuario
// en la galería de la app.
//
//   renderer/assets/widgets/thumbs/<key>.webp          widgets normales (las de la app)
//   renderer/assets/animations/thumbs/<tipo>-<pack>.webp animaciones (las de la app)
//   backoffice/src/assets/widget-thumbs/<key>.webp     capturas solo del backoffice
//                                                      (scripts/capture-widget-thumbs.cjs)
//
// Las de la app estan fuera del root de Vite: hace falta `server.fs.allow`
// en vite.config.js. Las capturas del backoffice viven aqui para no meterlas
// en el instalador de la app, donde no se usan.

const staticThumbs = {
  ...import.meta.glob('../../../renderer/assets/widgets/thumbs/*.webp', {
    eager: true,
    query: '?url',
    import: 'default'
  }),
  ...import.meta.glob('../assets/widget-thumbs/*.webp', {
    eager: true,
    query: '?url',
    import: 'default'
  })
};
const animThumbs = import.meta.glob('../../../renderer/assets/animations/thumbs/*.webp', {
  eager: true,
  query: '?url',
  import: 'default'
});

function byBasename(globResult) {
  const out = new Map();
  for (const [file, url] of Object.entries(globResult)) {
    const name = file.split('/').pop().replace(/\.webp$/i, '');
    out.set(name, url);
  }
  return out;
}

const STATIC = byBasename(staticThumbs);
const ANIM = byBasename(animThumbs);

// URL de la miniatura de un widget del catálogo, o null si no hay.
export function thumbFor(widget) {
  if (!widget) return null;
  if (widget.animation && widget.animType) {
    const variant = widget.animVariant || widget.pack;
    return ANIM.get(`${widget.animType}-${variant}`) || null;
  }
  return STATIC.get(String(widget.key).replace(/_/g, '-')) || null;
}
